import React from 'react';
import { isRouteErrorResponse } from 'react-router-dom';
import GenericError from './GenericError';
import { useRouteError } from 'react-router';
import { AppError } from '../utils/AppError';

const ErrorBoundaries: React.FC = () => {
  const error = useRouteError();

  const statusBasedMessage = (statusCode: number | string) => {
    switch (statusCode) {
      case 404:
        return 'The page you are looking for does not exist.';
      case 400:
        return 'Invalid request. Please verify the information and try again.';
      default:
        return 'Something went wrong.';
    }
  };

  if (isRouteErrorResponse(error)) {
    return (
      <GenericError
        content={{
          heading: `${error.status} ${error.statusText}`,
          status: error.status,
          message: error.data || 'An unexpected error occurred.',
          linkText: 'Go to Home',
          link: '/'
        }}
      />
    );
  } else if (error instanceof AppError) {
    return (
      <GenericError
        content={{
          heading: error?.errorText,
          status:
            typeof error.errorStatus === 'number'
              ? error.errorStatus
              : undefined,
          message: statusBasedMessage(error?.errorStatus ?? 500),
          linkText: 'Go to Home',
          link: '/'
        }}
      />
    );
  } else if (error instanceof Error) {
    return (
      <GenericError
        content={{
          heading: 'Unexpected Error',
          status: 500,
          message: error.message,
          linkText: 'Go to Home',
          link: '/'
        }}
      />
    );
  } else {
    return (
      <GenericError
        content={{
          heading: 'Unknown Error',
          status: 500,
          message: 'Something went wrong.',
          linkText: 'Go to Home',
          link: '/'
        }}
      />
    );
  }
};

export default ErrorBoundaries;
